module.exports = __webpack_public_path__ + "2d5b5c78083a6002f4aeffed779e7d45.MP3";